import { defineComponent as k, ref as O, onMounted as B, nextTick as I, h as R, renderSlot as M } from "vue";
import { useSsrAdapter as T } from "./ghl-ui.es749.js";
import { cssrAnchorMetaName as $, c as N } from "./ghl-ui.es750.js";
const n = "v-hidden", j = N("[v-hidden]", {
  display: "none!important"
}), D = k({
  name: "Overflow",
  props: {
    getCounter: Function,
    getTail: Function,
    updateCounter: Function,
    onUpdateCount: Function,
    onUpdateOverflow: Function
  },
  setup(e, { slots: m }) {
    const v = O(null), A = O(null);
    function p(U) {
      const { value: s } = v, { getCounter: b, getTail: c } = e;
      let o;
      if (b !== void 0 ? o = b() : o = A.value, !s || !o)
        return;
      o.hasAttribute(n) && o.removeAttribute(n);
      const { children: C } = s;
      if (U.showAllItemsBeforeCalculate)
        for (const t of C)
          t.hasAttribute(n) && t.removeAttribute(n);
      const d = s.offsetWidth, W = [], i = m.tail ? c == null ? void 0 : c() : null;
      let f = i ? i.offsetWidth : 0, a = !1;
      const w = s.children.length - (m.tail ? 1 : 0);
      for (let t = 0; t < w - 1; ++t) {
        if (t < 0)
          continue;
        const r = C[t];
        if (a) {
          r.hasAttribute(n) || r.setAttribute(n, "");
          continue;
        } else
          r.hasAttribute(n) && r.removeAttribute(n);
        const y = r.offsetWidth;
        if (f += y, W[t] = y, f > d) {
          const { updateCounter: x } = e;
          for (let l = t; l >= 0; --l) {
            const h = w - 1 - l;
            x !== void 0 ? x(h) : o.textContent = `${h}`;
            const g = o.offsetWidth;
            if (f -= W[l], f + g <= d || l === 0) {
              a = !0, t = l - 1, i && (t === -1 ? (i.style.maxWidth = `${d - g}px`, i.style.boxSizing = "border-box") : i.style.maxWidth = "");
              const { onUpdateCount: F } = e;
              F && F(h);
              break;
            }
          }
        }
      }
      const { onUpdateOverflow: u } = e;
      a ? u !== void 0 && u(!0) : (u !== void 0 && u(!1), o.setAttribute(n, ""));
    }
    const S = T();
    return j.mount({
      id: "vueuc/overflow",
      head: !0,
      anchorMetaName: $,
      ssr: S
    }), B(() => p({
      showAllItemsBeforeCalculate: !1
    })), {
      selfRef: v,
      counterRef: A,
      sync: p
    };
  },
  render() {
    const { $slots: e } = this;
    return I(() => this.sync({
      showAllItemsBeforeCalculate: !1
    })), R("div", {
      class: "v-overflow",
      ref: "selfRef"
    }, [
      M(e, "default"),
      // $slots.counter should only has 1 element
      e.counter ? e.counter() : R("span", {
        style: {
          display: "inline-block"
        },
        ref: "counterRef"
      }),
      // $slots.tail should only has 1 element
      e.tail ? e.tail() : null
    ]);
  }
});
export {
  D as default
};
